import { render, staticRenderFns } from "./DevAllotDetailDiv.vue?vue&type=template&id=2e74ecb4&scoped=true"
import script from "./DevAllotDetailDiv.vue?vue&type=script&lang=js"
export * from "./DevAllotDetailDiv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e74ecb4",
  null
  
)

export default component.exports